import {replaceNewLinesWithBrs} from '../../../../../utility/campaign/step/replaceNewLinesWithBrs.js';
import {replaceNewLinesWithSpaces} from '../../../../../utility/campaign/step/replaceNewLinesWithSpaces.js';
import {SocialPostPieceNames} from '../SocialPostPieceNames';

export const extractSocialPostStepPieces = {
  methods: {
    findPiece(name) {
      return this.pieces.find(piece => piece.name === name);
    },
  },
  computed: {
    msg() {
      const piece =
        this.findPiece(SocialPostPieceNames.PersonalMessage) || this.findPiece(SocialPostPieceNames.Message);
      return piece?.content ? replaceNewLinesWithBrs(piece?.content) : '';
    },
    image() {
      const piece = this.findPiece(SocialPostPieceNames.ImagePreview);
      return piece?.content;
    },
    description() {
      const piece = this.findPiece(SocialPostPieceNames.Description);
      return piece?.content ? replaceNewLinesWithBrs(piece?.content) : '';
    },
    title() {
      const piece = this.findPiece(SocialPostPieceNames.Title);
      return piece?.content ? replaceNewLinesWithSpaces(piece?.content) : '';
    },
    caption() {
      const piece = this.findPiece(SocialPostPieceNames.Caption);
      return piece?.content ? replaceNewLinesWithBrs(piece?.content) : '';
    },
    link() {
      const piece = this.findPiece(SocialPostPieceNames.Link);
      return piece?.content ? piece.content : '';
    },
    heading() {
      return this.caption || this.title;
    },
  },
};
